export default "__VITE_ASSET__6d6ae3a5__"